export default __webpack_public_path__ + "static/media/cointracker.53250a97.jpg";